import { Component, Inject, OnInit, Injectable, Optional, InjectionToken } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from '../services/global-functions.service';

declare const loadDocument: any;
declare const saveDocument: any;
declare const loadData: any;


@Component({
  selector: 'app-txc-mail-merge',
  templateUrl: './txc-mail-merge.component.html',
  styleUrls: ['./txc-mail-merge.component.scss']
})
export class TxcMailMergeComponent  implements OnInit {
  public _http: HttpClient;
  public _baseUrl: string;
  username: string;


  // @Inject('BASE_URL') baseUrl: string
  constructor(http: HttpClient, public gfunc: GlobalFunctionsService) {
    this._http = http;
    this._baseUrl = gfunc.WordTemplates_webRootPath;

    // get data source structure from Web API endpoint 'LoadData'
    http.get<any>(this._baseUrl + 'textcontrol/loaddata').subscribe(result => {

      // call JavaScript function from injected 'textcontrol.js'
      loadData(result);

    }, error => console.error(error));
  }



  ngOnInit(): void {

    this.username = 'my-text-control - TSA - tsa-textControlvBeta';
  }



  async onClickMergeDocument() {

    // get the saved document from TXTextControl
    let postDocument: MergedDocument = {
      document: await saveDocument(),
    };

    // post the document to endpoint 'MergeDocument'
    this._http.post<MergedDocument>(this._baseUrl + 'textcontrol/mergedocument', postDocument).subscribe(result => {

      // load the results into TXTextControl
      loadDocument(result.document);

    }, error => console.error(error));
  
  }



}


interface MergedDocument {
  document: string;
}